import React from 'react';
import {useTranslation} from 'react-i18next';
import {
  Flex, Typography, Popover, Select
} from "antd";
import IconDownloadFile from "../../ui/icons/IconDownloadFile";
import IconArrowDown from "../../ui/icons/IconArrowDown";
import {api} from "../../../api/apiProvider";

const {Text} = Typography;

interface KpiDataFileProps {
  key: string,
  fileUrl: string | undefined,
  fileName: string,
  inputId: string,
  onRemove: Function,
  editable: boolean,
}

export default function KpiDataFile({key, fileUrl, fileName, onRemove, inputId, editable}: KpiDataFileProps) {
  const {t} = useTranslation()

  return (
    <Flex gap={'small'} key={key}>
      {editable ?
        <Popover placement="bottomRight" content={
          <Flex className={'manager-tasks__popover'} vertical gap={'small'}
                justify={'flex-start'}>
            {fileUrl &&
              <a className={'manager-tasks__popover-item'}
                 href={'Javascript:void(0)'}
                 onClick={() => {
                   api.getFile(`${process.env.REACT_APP_PUBLIC_ENTRYPOINT}${fileUrl}`)
                 }}>
                {t('managerTasks.downloadFile')}
              </a>
            }
            <div className={'manager-tasks__popover-item'}
                 onClick={(e) => {
                   const block = document.querySelector('#' + inputId)
                   if (block) {
                     const input: HTMLElement | null = block.querySelector('input[type="file"]')

                     if (input) {
                       input.click()
                     }
                   }
                 }}>
              {t('managerTasks.updateFile')}
            </div>
            <div className={'manager-tasks__popover-item manager-tasks__popover-item_red'}
                 onClick={() => onRemove()}
            >
              {t('common.delete')}
            </div>
          </Flex>
        } arrow={false} trigger="click">
          <Flex className={'manager-tasks__file'} align={'center'}>
            <IconDownloadFile/>
            <span className={'manager-tasks__file-name'}>
                                <Text
                                  style={{width: 116}}
                                  ellipsis={{tooltip: fileName}}>{fileName}</Text>
                              </span>
            <IconArrowDown/>
          </Flex>
        </Popover>
        :
        <Select disabled/>
      }

    </Flex>
  )
}
